/* Mold Labs — cart drawer controller + quick-add (AJAX)
   Drives snippets/ml-cart-drawer.liquid: open/close, live re-render on
   add / quantity change / remove, free-freight progress, header count.
   Progressive enhancement: quick-add forms still POST to /cart/add without JS;
   the drawer's checkout + continue links are plain anchors. */
(function () {
  try { console.log('[Mold Labs] ml-cart.js v4 active'); } catch (e) {}
  var drawer = document.querySelector('[data-ml-cart]');

  /* ---------- money ---------- */
  // Formats Shopify cents using the shop's money_format (set in Settings → General →
  // Currency formatting). Falls back to a CZK-style "1 234 Kč" if no format is provided.
  var MONEY_FORMAT = (window.MLConfig && window.MLConfig.moneyFormat) || '{{amount}} Kč';

  function formatAmount(cents, fmt) {
    var value = cents / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount':
          return value.toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        case 'amount_no_decimals':
          return Math.round(value).toLocaleString('cs-CZ');
        case 'amount_with_comma_separator':
          return value.toFixed(2).replace('.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return Math.round(value).toLocaleString('cs-CZ');
        case 'amount_with_space_separator':
          return Math.round(value).toLocaleString('cs-CZ').replace(/\u00a0/g, ' ');
        case 'amount_with_apostrophe_separator':
          return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
        default:
          return value.toFixed(2);
      }
    });
  }
  function money(cents) { return formatAmount(cents, MONEY_FORMAT); }
  // expose for other scripts (PDP variant price)
  window.MLmoney = money;

  /* ---------- header count ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-ml-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
    var tc = document.querySelector('[data-ml-cart-titlecount]');
    if (tc) tc.textContent = '(' + n + ')';
  }

  /* ---------- open / close ---------- */
  var pendingAnimate = false;
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    pendingAnimate = true;
    animateItems(); // animate already-rendered rows immediately
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  // Staggered appear for each cart line.
  function animateItems() {
    if (!drawer) return;
    var rows = drawer.querySelectorAll('.ml-citem');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      row.style.animation = 'none';
      void row.offsetWidth; // reflow so the animation restarts
      row.style.animation = 'ml-citem-in .42s cubic-bezier(.22,1,.36,1) both';
      row.style.animationDelay = (i * 70) + 'ms';
    }
  }

  /* ---------- render ---------- */
  var prevCount = null; // for detecting freshly added lines

  function lineItemHTML(item, index, isNew) {
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="ml-citem__variant">' + item.variant_title + '</div>' : '';
    var img = item.featured_image && item.featured_image.url
      ? '<img src="' + item.featured_image.url + '" alt="">' : '';
    var newCls = isNew ? ' ml-citem--new' : '';
    return '' +
      '<div class="ml-citem' + newCls + '" data-ml-line="' + index + '" data-key="' + item.key + '">' +
        '<div class="ml-citem__img">' + img + '</div>' +
        '<div class="ml-citem__body">' +
          '<div class="ml-citem__name">' + item.product_title + '</div>' +
          variant +
          '<div class="ml-citem__row">' +
            '<div class="ml-citem__qty">' +
              '<button type="button" class="ml-citem__qbtn" data-ml-cart-qty="-1" aria-label="Ubrat">−</button>' +
              '<span class="ml-citem__qnum">' + item.quantity + '</span>' +
              '<button type="button" class="ml-citem__qbtn" data-ml-cart-qty="1" aria-label="Přidat">+</button>' +
            '</div>' +
            '<div class="ml-citem__price">' + money(item.final_line_price) + '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  var freeShipUnlocked = null; // track threshold-reached transitions

  function celebrate(el) {
    // pop the whole freight block
    el.style.animation = 'none';
    void el.offsetWidth;
    el.style.animation = 'ml-cart-pop .5s cubic-bezier(.2,1.4,.4,1)';
    // confetti burst
    var host = document.createElement('div');
    host.style.cssText = 'position:absolute;left:0;right:0;top:0;height:0;overflow:visible;pointer-events:none;';
    el.style.position = 'relative';
    el.appendChild(host);
    var colors = ['#5ccc78', '#2f9c57', '#0f0f0e', '#e9c46a'];
    for (var i = 0; i < 16; i++) {
      var bit = document.createElement('span');
      var c = colors[i % colors.length];
      var left = 8 + Math.random() * 84;
      var dx = (Math.random() * 60 - 30).toFixed(0);
      var rot = (Math.random() * 360).toFixed(0);
      var delay = (Math.random() * 90).toFixed(0);
      bit.style.cssText = 'position:absolute;top:4px;left:' + left + '%;width:7px;height:7px;border-radius:1px;background:' + c +
        ';opacity:0;transform:rotate(' + rot + 'deg);animation:ml-confetti .8s ease-out ' + delay + 'ms forwards;--dx:' + dx + 'px;';
      host.appendChild(bit);
    }
    setTimeout(function () { if (host.parentNode) host.parentNode.removeChild(host); }, 1100);
  }

  function renderFreight(panel, subtotal) {
    var el = drawer.querySelector('[data-ml-cart-freight]');
    if (!el) return;
    var threshold = parseInt(panel.getAttribute('data-ml-threshold'), 10) || 0;
    if (!threshold) { el.style.display = 'none'; return; }
    el.style.display = '';
    var remaining = Math.max(0, threshold - subtotal);
    var pct = Math.min(100, Math.round((subtotal / threshold) * 100));
    var unlocked = remaining <= 0;
    var text = remaining > 0
      ? 'Do dopravy zdarma zbývá ' + money(remaining)
      : 'Máte dopravu zdarma 🎉';

    // Build the structure ONCE; afterwards only update width + text so the CSS
    // width transition animates smoothly on each change (instead of snapping).
    var fill = el.querySelector('.ml-cart__freight-fill');
    var label = el.querySelector('.ml-cart__freight-text');
    if (!fill || !label) {
      el.innerHTML =
        '<div class="ml-cart__freight-text" style="font-family:\'Space Mono\',monospace;font-size:11px;letter-spacing:.06em;color:#5a5a52;margin-bottom:9px;">' + text + '</div>' +
        '<div class="ml-cart__freight-track" style="height:8px!important;border-radius:5px;background:#ecece5;overflow:hidden;display:block!important;">' +
          '<div class="ml-cart__freight-fill" style="display:block!important;height:8px!important;min-width:22px;width:0%;border-radius:5px;background-color:#5ccc78!important;background-image:linear-gradient(90deg,#5ccc78,#7ddc95,#5ccc78);background-size:200% 100%;animation:ml-freight-flow 2.6s linear infinite;transition:width .6s cubic-bezier(.22,1,.36,1);"></div>' +
        '</div>';
      fill = el.querySelector('.ml-cart__freight-fill');
      label = el.querySelector('.ml-cart__freight-text');
      // let the browser paint 0% first, then animate to the real width next frame
      requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = pct + '%'; }); });
    } else {
      fill.style.width = pct + '%';
    }
    label.textContent = text;

    // Celebrate the moment free shipping is first reached (not on every render).
    if (unlocked && freeShipUnlocked === false) { try { celebrate(el); } catch (e) {} }
    freeShipUnlocked = unlocked;
  }

  function render(cart) {
    if (!drawer) return;
    var panel = drawer.querySelector('[data-ml-cart-panel]');

    // Freight bar + count FIRST, each guarded, so a later failure can never freeze them.
    try { setCount(cart.item_count); } catch (e) {}
    try {
      renderFreight(panel, cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
    } catch (e) {}

    try {
      var items = drawer.querySelector('[data-ml-cart-items]');
      if (cart.item_count === 0) {
        items.innerHTML = '<div class="ml-cart__empty">Váš košík je prázdný.</div>';
      } else {
        items.innerHTML = cart.items.map(function (it, i) { return lineItemHTML(it, i + 1); }).join('');
      }
      prevCount = cart.item_count;
    } catch (e) {}

    try {
      var foot = drawer.querySelector('[data-ml-cart-foot]');
      if (foot) foot.hidden = cart.item_count === 0;
      var sub = drawer.querySelector('[data-ml-cart-subtotal]');
      if (sub) sub.textContent = money(cart.total_price);
      var chk = drawer.querySelector('[data-ml-cart-checkprice]');
      if (chk) chk.textContent = money(cart.total_price);
    } catch (e) {}

    // If the drawer was just opened, play the staggered line-item appear.
    if (pendingAnimate) { pendingAnimate = false; animateItems(); }
  }

  /* ---------- cart API ---------- */
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }
  function refresh() { return getCart().then(render); }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    // close
    if (e.target.closest('[data-ml-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    // header cart icon → open drawer instead of navigating
    var cartLink = e.target.closest('.ml-header__cart');
    if (cartLink && drawer) { e.preventDefault(); openDrawer(); refresh(); return; }
    // qty buttons
    var qbtn = e.target.closest('[data-ml-cart-qty]');
    if (qbtn) {
      e.preventDefault();
      var row = qbtn.closest('[data-ml-line]');
      if (!row) return;
      var line = parseInt(row.getAttribute('data-ml-line'), 10);
      var cur = parseInt(row.querySelector('.ml-citem__qnum').textContent, 10) || 1;
      var next = cur + parseInt(qbtn.getAttribute('data-ml-cart-qty'), 10);
      changeLine(line, Math.max(0, next)).then(render);
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* quick-add (product cards + PDP) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ml-quickadd]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"], button:not([type])');
    if (btn) btn.disabled = true;
    var qtyField = form.querySelector('[name="quantity"]');
    var onCartPage = !!document.querySelector('.ml-cartpage');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: form.querySelector('[name="id"]').value,
        quantity: qtyField ? (parseInt(qtyField.value, 10) || 1) : 1
      })
    }).then(function () {
      if (onCartPage) {
        // On the cart page: update the page in place, do NOT open the drawer.
        return refreshCartPage();
      }
      return refresh().then(function () { openDrawer(); });
    })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  /* Re-render the cart page's content in place after an upsell add. */
  function refreshCartPage() {
    var inner = document.querySelector('.ml-cartpage__inner');
    if (!inner) { window.location.reload(); return Promise.resolve(); }
    // Remember the freight progress BEFORE the swap so we can tween from it.
    var oldBar = inner.querySelector('[data-ml-cartpage-freight]');
    var fromPct = oldBar ? (parseFloat(oldBar.getAttribute('data-pct')) || 0) : 0;
    return fetch(window.location.pathname + '?t=' + Date.now(), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.ml-cartpage__inner');
        if (!fresh) { window.location.reload(); return; }
        inner.innerHTML = fresh.innerHTML;
        // Stagger the line items in, just like the drawer.
        animateCartPageLines(inner);
        // Grow the green bar smoothly from its previous fill; celebrate on unlock.
        animateCartPageFreight(inner, fromPct);
      })
      .catch(function () { window.location.reload(); });
  }

  // Staggered appear for the cart-page line items (mirrors the drawer).
  function animateCartPageLines(scope) {
    var rows = scope.querySelectorAll('.ml-cartline');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      row.style.animation = 'none';
      void row.offsetWidth;
      row.style.animation = 'ml-citem-in .42s cubic-bezier(.22,1,.36,1) both';
      row.style.animationDelay = (i * 70) + 'ms';
    }
  }

  // Animate the green free-shipping bar's width from its previous value, and
  // fire the confetti + pop the moment free shipping is reached.
  function animateCartPageFreight(scope, fromPct) {
    var bar = scope.querySelector('[data-ml-cartpage-freight]');
    if (!bar) return;
    var toPct = parseFloat(bar.getAttribute('data-pct')) || 0;
    var rects = bar.querySelectorAll('svg rect');
    var fill = rects.length > 1 ? rects[1] : null; // second rect is the green fill
    if (fill) {
      var start = null, dur = 650;
      fill.setAttribute('width', fromPct + '%');
      function step(ts) {
        if (start === null) start = ts;
        var t = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
        fill.setAttribute('width', (fromPct + (toPct - fromPct) * eased).toFixed(2) + '%');
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    // Reached free shipping on this add → celebrate.
    if (toPct >= 100 && fromPct < 100) {
      bar.style.position = 'relative';
      try { celebrate(bar); } catch (e) {}
    }
  }

  /* ---------- init ---------- */
  function renderCartPageFreight() {
    var el = document.querySelector('[data-ml-cartpage-freight]');
    if (el) {
      // New section version renders a self-contained SVG bar — nothing to do.
      if (el.querySelector('svg')) { return; }
      var pct = parseInt(el.getAttribute('data-pct'), 10) || 0;
      var msg = el.getAttribute('data-msg') || '';
      var wrap = document.createElement('div');
      wrap.className = 'ml-cart__freight-text';
      wrap.style.cssText = 'font-family:\'Space Mono\',monospace;font-size:11px;letter-spacing:.06em;color:#5a5a52;margin-bottom:9px;';
      wrap.textContent = msg;
      // Paint EVERYTHING directly on the elements. Class rules for the track/fill
      // get zeroed/collapsed on the live store, so we do not rely on them at all.
      var track = document.createElement('div');
      track.className = 'ml-cart__freight-track';
      track.style.height = '8px';
      track.style.borderRadius = '5px';
      track.style.background = '#ecece5';
      track.style.overflow = 'hidden';
      track.style.width = '100%';
      var fill = document.createElement('div');
      fill.className = 'ml-cart__freight-fill';
      fill.style.width = pct + '%';
      fill.style.height = '8px';
      fill.style.minWidth = '22px';
      fill.style.borderRadius = '5px';
      fill.style.background = '#5ccc78';
      fill.style.backgroundImage = 'linear-gradient(90deg,#5ccc78,#7ddc95,#5ccc78)';
      fill.style.backgroundSize = '200% 100%';
      fill.style.transition = 'width .6s cubic-bezier(.22,1,.36,1)';
      fill.style.animation = 'ml-freight-flow 2.6s linear infinite';
      track.appendChild(fill);
      el.textContent = '';
      el.appendChild(wrap);
      el.appendChild(track);
      return;
    }
    // Fallback: older server-rendered markup is present (section not re-uploaded).
    // Add the drawer's classes so the injected green rule styles it.
    var oldFill = document.querySelector('.ml-cartpage__freight-fill');
    var oldTrack = document.querySelector('.ml-cartpage__freight-track');
    if (oldTrack) {
      oldTrack.classList.add('ml-cart__freight-track');
      oldTrack.style.height = '8px';
      oldTrack.style.borderRadius = '5px';
      oldTrack.style.background = '#ecece5';
      oldTrack.style.overflow = 'hidden';
    }
    if (oldFill) {
      oldFill.classList.add('ml-cart__freight-fill');
      oldFill.style.height = '8px';
      oldFill.style.minWidth = '22px';
      oldFill.style.borderRadius = '5px';
      oldFill.style.background = '#5ccc78';
      oldFill.style.backgroundImage = 'linear-gradient(90deg,#5ccc78,#7ddc95,#5ccc78)';
      oldFill.style.backgroundSize = '200% 100%';
      oldFill.style.animation = 'ml-freight-flow 2.6s linear infinite';
      // if the server stripped the inline width, recover it from the gradient stop if any
      if (!oldFill.style.width) {
        var m = (oldTrack && oldTrack.getAttribute('style') || '').match(/#5ccc78\s+(\d+)%/);
        if (m) { oldFill.style.width = m[1] + '%'; }
      }
    }
  }

  function injectCriticalCSS() {
    if (document.getElementById('ml-cart-critical')) return;
    var css =
      '.ml-cart{position:fixed!important;inset:0!important;z-index:99999!important;visibility:hidden;opacity:0;pointer-events:none;transition:opacity .25s ease;}' +
      '.ml-cart.is-open{visibility:visible;opacity:1;}' +
      '.ml-cart__overlay{position:absolute;inset:0;background:transparent;pointer-events:none;}' +
      '.ml-cart__panel{position:absolute;top:14px;right:14px;bottom:14px;height:auto;width:392px;max-width:calc(100% - 28px);background:#fff;display:flex;flex-direction:column;box-sizing:border-box;box-shadow:-24px 0 70px -18px rgba(0,0,0,.4);border-radius:24px;overflow:hidden;pointer-events:auto;}' +
      '.ml-cart.is-open .ml-cart__panel{animation:ml-cart-slidein .42s cubic-bezier(.3,.9,.3,1) both;}' +
      '@keyframes ml-cart-slidein{from{transform:translateX(40px);opacity:0;}to{transform:translateX(0);opacity:1;}}' +
      '.ml-cart__items{flex:1;overflow:auto;}' +
      '.ml-cart__freight-track{height:8px!important;border-radius:5px!important;background:#ecece5!important;overflow:hidden!important;}' +
      '.ml-cart__freight-fill{height:8px!important;min-width:22px!important;border-radius:4px!important;background:#5ccc78!important;background-image:linear-gradient(90deg,#5ccc78,#7ddc95,#5ccc78)!important;background-size:200% 100%!important;transition:width .6s cubic-bezier(.22,1,.36,1)!important;animation:ml-freight-flow 2.6s linear infinite!important;}' +
      '@keyframes ml-freight-flow{0%{background-position:0% 0;}100%{background-position:-200% 0;}}' +
      '@keyframes ml-citem-in{from{opacity:0;transform:translateY(10px);}to{opacity:1;transform:translateY(0);}}' +
      '@keyframes ml-cart-pop{0%{transform:scale(1);}40%{transform:scale(1.05);}100%{transform:scale(1);}}' +
      '@keyframes ml-confetti{0%{opacity:1;transform:translate(0,0) rotate(0);}100%{opacity:0;transform:translate(var(--dx,0),34px) rotate(220deg);}}' +
      /* ---- cart PAGE (/cart) critical styles — the section {% stylesheet %} isn't reliably applied when dropped into Dawn, so force the essentials here ---- */
      '.ml-cartpage__freight-track{height:8px!important;border-radius:5px!important;overflow:hidden!important;}' +
      '.ml-cartline__qty{display:inline-flex!important;align-items:center!important;border:1px solid #e0e0d8!important;border-radius:8px!important;width:max-content!important;height:auto!important;}' +
      '.ml-cartline__qbtn{width:26px!important;height:30px!important;min-width:0!important;padding:0!important;display:flex!important;align-items:center!important;justify-content:center!important;text-decoration:none!important;color:#6e6e66!important;font-size:15px!important;background:none!important;border:none!important;}' +
      '.ml-cartline__qnum{width:26px!important;text-align:center!important;font-size:14px!important;font-weight:700!important;color:#0f0f0e!important;padding:0!important;}';
    var s = document.createElement('style');
    s.id = 'ml-cart-critical';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function init() {
    injectCriticalCSS();
    renderCartPageFreight();
    // The drawer is rendered inside the header section. A sticky/transformed/overflow
    // parent there can clip it, steal clicks, or break position:fixed. Move it to be a
    // direct child of <body> (and drop any stale duplicate) so it's always a clean overlay.
    var all = document.querySelectorAll('[data-ml-cart]');
    for (var i = 1; i < all.length; i++) { all[i].parentNode.removeChild(all[i]); }
    drawer = document.querySelector('[data-ml-cart]');
    if (drawer && drawer.parentElement !== document.body) { document.body.appendChild(drawer); }

    refresh();
    var hdr = document.querySelector('[data-ml-header]');
    if (hdr) {
      var onScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 4); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var toggle = document.querySelector('[data-ml-navtoggle]');
    var nav = document.querySelector('[data-ml-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    setupNavUnderline();
    setupCareTempDot();
  }

  /* ---------- active nav underline ----------
     Matched from the current URL and painted DIRECTLY on the element, so it
     works even when the live store strips the section CSS or the menu setting
     leaves everything on the first link. */
  function setupNavUnderline() {
    var nav = document.querySelector('[data-ml-nav]');
    if (!nav) return;
    var links = [].slice.call(nav.querySelectorAll('.ml-header__navlink'));
    if (!links.length) return;
    var green = (getComputedStyle(document.documentElement).getPropertyValue('--ml-green').trim()) || '#5ccc78';
    var ink = (getComputedStyle(document.documentElement).getPropertyValue('--ml-ink').trim()) || '#0f0f0e';
    var norm = function (p) { p = (p || '').replace(/[?#].*$/, '').replace(/\/+$/, ''); return p === '' ? '/' : p; };
    var here = norm(window.location.pathname);
    var best = null, bestLen = -1;
    links.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href === '' || href === '#') return;
      var lp;
      try { lp = norm(new URL(href, window.location.origin).pathname); } catch (e) { return; }
      if (lp === '/') return; // don't let "home" swallow every page
      if ((here === lp || here.indexOf(lp + '/') === 0) && lp.length > bestLen) { best = a; bestLen = lp.length; }
    });
    links.forEach(function (a) {
      a.classList.remove('is-active');
      a.removeAttribute('aria-current');
      a.style.borderBottom = '2px solid transparent';
    });
    if (best) {
      best.classList.add('is-active');
      best.setAttribute('aria-current', 'page');
      best.style.borderBottom = '2px solid ' + green;
      best.style.color = ink;
    }
  }

  /* ---------- care page: temperature status dot ----------
     Orange dot in the "Pečení" zone, red in "Vysoký žár", green elsewhere.
     Colour is set directly on the dot element so it survives style-stripping,
     and runs independently of the care section's own script. */
  function setupCareTempDot() {
    var temp = document.querySelector('[data-care-temp]');
    if (!temp) return;
    var range = temp.querySelector('[data-care-temp-range]');
    var dot = temp.querySelector('.ml-care__temp-dot');
    if (!range || !dot) return;
    var green = (getComputedStyle(document.documentElement).getPropertyValue('--ml-green').trim()) || '#5ccc78';
    // Thresholds mirror the section's zone breakpoints (°C).
    // Pečení = 100–199, Vysoký žár = 200+.
    var paint = function () {
      var t = parseInt(range.value, 10);
      if (t >= 200) {            // Vysoký žár
        dot.style.background = '#E0473F';
        dot.style.animation = 'none';
        dot.style.boxShadow = '0 0 0 4px rgba(224,71,63,0.22)';
      } else if (t >= 100) {     // Pečení
        dot.style.background = '#E8833A';
        dot.style.animation = 'none';
        dot.style.boxShadow = '0 0 0 4px rgba(232,131,58,0.22)';
      } else if (t < 40) {       // mražení + chlazení — modrá
        dot.style.background = '#3F86E0';
        dot.style.animation = 'none';
        dot.style.boxShadow = '0 0 0 4px rgba(63,134,224,0.22)';
      } else {                   // safe range — brand green
        dot.style.background = green;
        dot.style.animation = '';
        dot.style.boxShadow = '';
      }
    };
    range.addEventListener('input', paint);
    paint();
  }
  // Run now if the DOM is already parsed (deferred/late script), else wait.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
